import React, { useEffect, useState } from "react";
import Input from "./InputTypes/Input";
import { FormField } from "../FormField";
import { ErrorMessage, useFormikContext} from "formik";
import { Dropdown } from "primereact/dropdown";
import ToggleField from "../ToggleField";
import { MultiSelect } from "primereact/multiselect";

const FormPreview = ({ dynamicFields,fieldName, values, handleFieldChange }) => {
  const { setFieldValue } = useFormikContext();

  const [formData, setFormData] = useState(
    dynamicFields?.length &&
      dynamicFields?.reduce((acc, field) => {
        acc[field.attributes.name] = field.attributes.value || "";
        return acc;
      }, {})
  );

  const handleChange = (name, value) => {
    const data={
      ...values,
      [name]: value,
    }
    setFieldValue(fieldName, data);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    setFormData(
      dynamicFields &&
        dynamicFields?.reduce((acc, field) => {
          acc[field.attributes.name] = field.attributes.value || "";
          return acc;
        }, {})
    );
  }, []);

  if (dynamicFields && dynamicFields?.length) {
    return dynamicFields?.map((field, index) => {
      return (
        <InputTypeRender
          key={index}
          field={field}
          values={values}
          handleChange={handleChange}
        />
      );
    });
  }
};

export default FormPreview;


const InputTypeRender=({key,field,values,handleChange})=>{

  switch (field?.type) {
    case "boolean":
     return(<div id={`${field?.attributes?.name}`}>
      <ToggleField
        text={`${field?.label}`}       
        {...field.attributes}
        value={Boolean(values?.[field?.attributes?.name])||false}
        toggaleHandleChange={() => {
          handleChange(field.attributes.name, !Boolean(values?.[field?.attributes?.name]||false))
        }
      }
      />
      <ErrorMessage
          name={`${field?.attributes?.name}`}
        component="div"
        className="error"
      />
    </div>)
    case "multiselect":
      return (
        <FormField label={field.label} tooltip={`Choose ${field.label}`}>
          <div className="flex items-center" id="item_name">
            <MultiSelect
              disabled={
                field?.attributes?.disabled && field?.attributes?.disabled
              }
              value={values?.[field?.attributes?.name] || null}
              onChange={(e) =>
                handleChange(field.attributes.name, e.target.value)
              }
              options={
                field?.attributes?.options
                  ? field?.attributes?.options?.split(",")
                  : []
              }
              // optionLabel={field?.attributes?.optionLabel||'name'}
              // optionValue={field?.attributes?.optionValue||""}
              placeholder={field?.attributes?.placeholder || ""}
              // filter
              className="w-full border-gray-400"
              style={{ borderRadius: "1px" }}
            />
          </div>
          <ErrorMessage
            name={`${field?.attributes?.name}`}
            component="div"
            className="error"
          />
        </FormField>
      );
     
    // case "range":
    
    case "dropdown":
      return(<div key={key} className="border-gray-400">          
        <FormField label={field.label} tooltip={`Choose ${field.label}`}>          
                  <div className="flex items-center" id="item_name">   
            <Dropdown              
                disabled={field?.attributes?.disabled&&field?.attributes?.disabled}
                value={values?.[field?.attributes?.name]||null}
                onChange={(e) => handleChange(field.attributes.name, e.target.value)}          
                options={field?.attributes?.options?field?.attributes?.options?.split(','):[]} 
                // optionLabel={field?.attributes?.optionLabel||'name'} 
                // optionValue={field?.attributes?.optionValue||""}
                placeholder={field?.attributes?.placeholder||''} 
                // filter                 
                className="w-full border-gray-400"    
                style={{borderRadius:'1px'}}         
            />
        </div> 
                  <ErrorMessage
                    name={`${field?.attributes?.name}`}
                    component="div"
                    className="error"
                  />
        </FormField>
      </div>)
    default:
      return (<div key={key}>          
            <FormField label={field.label} tooltip={`Enter ${field.label}`}>
              {/* {JSON.stringify(field )} */}
                      <div className="flex items-center" id="item_name">                      
                        <Input
                           {...field.attributes}
                           type={field?.type||'text'}
                          //  value={formData && formData[field?.attributes?.name]}
                           value={values?.[field?.attributes?.name]||null}
                           onChange={(e) => handleChange(field.attributes.name, e.target.value)}                       
                        />
                      </div>
                      <ErrorMessage
                        name={`${field?.attributes?.name}`}
                        component="div"
                        className="error"
                      />
            </FormField>
          </div>);
  }

}